import React, { Component } from 'react';
import { Big3Common, bootstrap } from "../../../js/IncludeManager";
import { Alert } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:아이디 찾기, 사업자 번호를 사용해야 하나 현재 소매에서 등록된 사업자가 없어서 히든처리 상태
 * 세부설명:
*/

export class FindID extends Component {
    static displayName = FindID.name;

    constructor(props) {
        super(props);
        this.state = {
            FindModel: {
                User_Name: "",
                User_Phone: "",
                Org_No: "",
            },
            nameModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            phonModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            orgNumModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            FindUserID: "",
            Title: "",
            BtnFindOk: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleClear_Click = this.handleClear_Click.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }
    jsonAttr = { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false }
    //검증속성 기본값
    AttrDefaultSet() {
        this.jsonAttr.Hide = "item_hide"; //input_txt,item_hide
        this.jsonAttr.Msg = "";
        this.jsonAttr.CheckOk = false;
        this.jsonAttr.ChkCss = "item_hide"; //false,check,item_hide
    }
    //검증속성 Good
    AttrCheckOkSet() {
        this.jsonAttr.Hide = "input_txt";
        this.jsonAttr.Msg = "";
        this.jsonAttr.CheckOk = true;
        this.jsonAttr.ChkCss = "check";
    }
    //검증속성 No Good
    AttrErrorSet(Msg) {
        this.jsonAttr.Hide = "input_txt";
        this.jsonAttr.Msg = Msg;
        this.jsonAttr.CheckOk = false;
        this.jsonAttr.ChkCss = "false";
    }
    handleChange(event) {
        let tagId = event.target.id;
        let value = event.target.value.trim();
        if (tagId === "User_Phone" || tagId === "Org_No") {
            //핸드폰,인증번호 숫자만 입력 되게 처리
            let StringText = value.replace(/-/gi, '');
            if (Big3Common.Util.isNumber(StringText) === false) {
                return false;
            }
        }
        Big3Common.ValueCahage_StateUpdate({ this: this, event: event, modelName: "FindModel" });
        event.preventDefault();
    }
    async handleSearch_Click(event) {

        if (!this.state.BtnFindOk) return false;
        let Data = await Big3Common.Post("api/Account/LoginMgr/FindLogiId", this.state.FindModel, true);
        if (Data.codeName === Big3Common.ResultCode.Success) {
            let objJson = JSON.parse(Data.dataTable);
            if (objJson.length > 0) {
                this.setState({ FindUserID: objJson[0]["login_id"] });
                Big3Common.ModalAlert(bootstrap, 'FindIdMsg');
            }
        }
        else {
            this.setState({ Title: Data.message });
            Big3Common.ModalAlert(bootstrap, 'FindIdAlert');
        }

        event.preventDefault();
    }
    //X버튼 클릭시 초기화
    handleClear_Click(tagId) {
        let ModelName = this.GetModelName(tagId);
        this.AttrDefaultSet();
        //value 값 초기화
        Big3Common.updateStateModel({ this: this, modelName: "FindModel", updateModel: { [tagId]: "" } })
        //속성값 초기화
        this.AttrDefaultSet();
        Big3Common.updateStateModel({ this: this, modelName: ModelName, updateModel: this.jsonAttr });
        return false;
    }
    handleBlur(event) {
        let tagId = event.target.id;
        let ModelName = this.GetModelName(tagId);
        let ModelValue = this.state.FindModel[tagId];
        let ModelLen = ModelValue.length;
        if (ModelLen === 0) {
            this.AttrDefaultSet();
        }

        if (tagId === "User_Name" && ModelLen > 0) {
            this.AttrCheckOkSet();
        }
        else if (tagId === "User_Phone" && ModelLen > 0) {
            let isCheck = Big3Common.Util.HandPhoneCheck(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("핸드폰번호 형식이 잘못 되었습니다.");
            }
            else {
                let hpFormat = Big3Common.Util.HandPhoneFormat(ModelValue);
                Big3Common.updateStateModel({ this: this, modelName: "FindModel", updateModel: { [tagId]: hpFormat } });
                this.AttrCheckOkSet();
            }
        }
        else if (tagId === "Org_No" && ModelLen > 0) {
            let isCheck = Big3Common.Util.OrgNumberCheck(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("사업자번호 형식이 잘못 되었습니다.");
            }
            else {
                this.AttrCheckOkSet();
            }
        }
        if (ModelName === "") return false;

        Big3Common.updateStateModel({ this: this, modelName: ModelName, updateModel: this.jsonAttr });

        if (this.state.nameModel.CheckOk === true && this.state.phonModel.CheckOk === true) {
            this.setState({ BtnFindOk: true });
        }

        event.preventDefault();
    }
    //모델이름 반환
    GetModelName(tagId) {
        let ModelName = "";
        if (tagId === "User_Name") {
            ModelName = "nameModel";
        }
        else if (tagId === "User_Phone") {
            ModelName = "phonModel";
        }
        else if (tagId === "Org_No") {
            ModelName = "orgNumModel";
        }
        return ModelName;
    }
    //로그인 가기
    handleLogin(event) {
        Big3Common.ModalClose(bootstrap, 'FindIdMsg');
        this.props.RenderComponent('SignIn');
        event.preventDefault();
    }
    //초기화
    componentDidMount() {
    }
    //확인 팝업은 공통으로 사용하지 않아서 페이지에 등록 함.
    ConfirmRender() {
        return (
            <div className="modal fade choose main_modal" id="FindIdMsg" tabIndex="-1" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <button type="button" className="modal_in_close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className="icon icon-check"></div>
                            <div className="desc">
                                <div className="modal_title">아이디확인</div>
                                <div className="modal_txt">회원님의 아이디는 <span>{this.state.FindUserID}</span>입니다.</div>
                            </div>
                            <div className="btn-wrap">
                                {/*이벤트 함수이용 직접 링크 걸기*/}
                                <a href="#!" className="text-secondary" onClick={this.handleLogin} >로그인하기</a>
                                {/*이벤트 함수없이 직접 링크 걸기*/}
                                <a href="#!" className="text-secondary" onClick={(e) => { this.props.RenderComponent('FindPwd'); Big3Common.ModalClose(bootstrap, 'FindIdMsg'); e.preventDefault(); }} >비밀번호찾기</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    buttonRender() {
        return (
            <button type="button" className={this.state.BtnFindOk === true ? "btn_v btn_v1" : "btn_v btn_inactive"} onClick={this.handleSearch_Click} >아이디 찾기</button>
        )
    }
    render() {
        let ConfirmRender = this.ConfirmRender();
        let buttonRender = this.buttonRender();
        return (
            <div>
                <div className="input_box">
                    <div className="input_line">
                        <label>이름</label>
                        <input type="text"
                            className="form-control"
                            id="User_Name"
                            value={this.state.FindModel.User_Name}
                            onChange={this.handleChange}
                            maxLength="20"
                            placeholder="이름을 입력하세요"
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.nameModel.ChkCss} onClick={() => this.handleClear_Click('User_Name')} ></div>
                        <div className={this.state.nameModel.Hide} >{this.state.nameModel.Msg}</div>
                    </div>
                    <div className="input_line">
                        <label>휴대폰번호</label>
                        <input type="tel"
                            className="form-control"
                            id="User_Phone"
                            value={this.state.FindModel.User_Phone}
                            onChange={this.handleChange}
                            maxLength="13"
                            placeholder="휴대폰번호를 입력하세요. (-는 제외)"
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.phonModel.ChkCss} onClick={() => this.handleClear_Click('User_Phone')} ></div>
                        <div className={this.state.phonModel.Hide}>{this.state.phonModel.Msg}</div>
                    </div>
                    <div className="input_line item_hide">
                        <label>사업자등록번호</label>
                        <input type="text"
                            className="form-control"
                            id="Org_No"
                            value={this.state.FindModel.Org_No}
                            onChange={this.handleChange}
                            maxLength="12"
                            placeholder="사업자등록번호를 입력하세요."
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.orgNumModel.ChkCss} onClick={() => this.handleClear_Click('Org_No')} ></div>
                        <div className={this.state.orgNumModel.Hide}>{this.state.orgNumModel.Msg}</div>
                    </div>
                </div>
                <div className="button_line bottom_line">
                    {buttonRender}
                </div>
                <Alert
                    id="FindIdAlert"
                    content=""
                    title={this.state.Title}
                />
                {ConfirmRender}
            </div>

        );
    }
}
